<template>
  <v-alert
    border="top"
    colored-border
    type="info"
    color="orange"
    elevation="2"
  >
    {{ msg }}
  </v-alert>
</template>
<script type="text/javascript">
export default {
  name: 'QuestionnaireFieldTip',
  props: {
    msg: {
      type: String,
      default: '',
    },
  },
}
</script>